export const featuresLQOP1 = {
    fr: [
        "144 condos locatifs",
        "12 étages préfabriqués en béton",
        "2 étage de stationnements sous-terrains",
        "18 mois d'éxécution",
        "Mandat forfaitaire"
    ],
    en: [
        "93 rental condos",
        "4 stories made of prefabricated steel and concrete",
        "1 underground parking level",
        "14 months of execution",
        "Lump-sum contract",
    ]

}